/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_HelpInputs */

const en_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The type of content this group contains`)
};

const fr_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le type de contenu que ce groupe contient`)
};

const de_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Art der Inhalte, die diese Gruppe enthält`)
};

const it_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tipo di contenuto contenuto in questo gruppo`)
};

const ru_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип контента, который содержит эта группа.`)
};

const es_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tipo de contenido que contiene este grupo`)
};

const zh_cn2_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此组包含的内容类型`)
};

const ja_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このグループに含まれるコンテンツの種類`)
};

const hi_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समूह में मौजूद सामग्री का प्रकार`)
};

const pt_pt2_edit_event_group_type_help = /** @type {(inputs: Edit_Event_Group_Type_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tipo de conteúdo que este grupo contém.`)
};

/**
* | output |
* | --- |
* | "The type of content this group contains" |
*
* @param {Edit_Event_Group_Type_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_help = /** @type {((inputs?: Edit_Event_Group_Type_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_help(inputs)
	if (locale === "de") return de_edit_event_group_type_help(inputs)
	if (locale === "it") return it_edit_event_group_type_help(inputs)
	if (locale === "ru") return ru_edit_event_group_type_help(inputs)
	if (locale === "es") return es_edit_event_group_type_help(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_help(inputs)
	if (locale === "ja") return ja_edit_event_group_type_help(inputs)
	if (locale === "hi") return hi_edit_event_group_type_help(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_help(inputs)
	return en_edit_event_group_type_help(inputs)
});